import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=add0b640&"
import script from "./Container.vue?vue&type=script&lang=js&"
export * from "./Container.vue?vue&type=script&lang=js&"
import style0 from "./Container.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Container.vue?vue&type=custom&index=0&blockType=doc"
if (typeof block0 === 'function') block0(component)

export default component.exports